import { atom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';
import { SelectItem } from '../../../types';
import { defaultDateRange } from './useAllTransactionsData';

export const fundFilterState = atom<SelectItem[] | null>(null);

export const transactionTypeFilterState = atom<SelectItem[] | null>(null);

export const transactionsDateFilterState = atom<{ fromDate: string; toDate: string }>({
  fromDate: defaultDateRange().fromDate,
  toDate: defaultDateRange().toDate,
});

export function useResetTransactionFilters() {
  return useAtomCallback(
    useCallback((get, set) => {
      set(fundFilterState, null);
      set(transactionTypeFilterState, null);
      set(transactionsDateFilterState, {
        fromDate: defaultDateRange().fromDate,
        toDate: defaultDateRange().toDate,
      });
    }, [])
  );
}
